import {
    Drawer,
    Portal,
    VStack,
    Grid,
    Input,
    Button,
    Text,
    Box,
    HStack,
} from "@chakra-ui/react";

import {
    useState,
    useEffect,
} from "react";

import AttachmentUpload from "../../../components/AttachmentUpload";

const AddDriverVehicleDrawer = ({
    open,
    onClose,
    driver,
    onSubmit,
    loading = false,
}) => {
    const [
        form,
        setForm,
    ] = useState({
        registration_number: "",
        vehicle_make: "",
        vehicle_model: "",
        vehicle_body_type: "",
        vehicle_color: "",
        chasis_number: "",
        engine_number: "",
        year_of_manufacturing: "",

        blue_book: [],
        vehicle_image: [],
    });

    useEffect(() => {
        if (!open) {
            setForm({
                registration_number: "",
                vehicle_make: "",
                vehicle_model: "",
                vehicle_body_type: "",
                vehicle_color: "",
                chasis_number: "",
                engine_number: "",
                year_of_manufacturing: "",

                blue_book: [],
                vehicle_image: [],
            });
        }
    }, [open]);

    const handleSubmit =
    async () => {
        if (
            onSubmit
        ) {
            await onSubmit(
                driver,
                form
            );
        }
    };

    const isFormComplete =
    form.registration_number &&
    form.vehicle_make &&
    form.vehicle_model &&
    form.vehicle_body_type &&
    form.vehicle_color &&
    form.chasis_number &&
    form.engine_number &&
    form.year_of_manufacturing &&
    form.blue_book.length > 0 &&
    form.vehicle_image.length > 0;

    return (
        <Drawer.Root
            open={open}
            onOpenChange={(
                details
            ) => {
                if (
                    !details.open
                ) {
                    onClose();
                }
            }}
            size="lg"
        >
            <Portal>
                <Drawer.Backdrop />

                <Drawer.Positioner>
                    <Drawer.Content>
                        <Drawer.Header
                            borderBottom="1px solid"
                            borderColor="gray.200"
                        >
                            <Drawer.Title>
                                Add Driver Vehicle
                            </Drawer.Title>

                            <Text
                                color="gray.500"
                                fontSize="sm"
                                mt={1}
                            >
                                Register a vehicle for{" "}
                                {
                                    driver
                                        ?.user
                                        ?.username ||
                                    driver?.username
                                }
                            </Text>
                        </Drawer.Header>

                        <Drawer.Body
                            py={6}
                        >
                            <VStack
                                gap={8}
                                align="stretch"
                            >
                                <Grid
                                    templateColumns="repeat(2,1fr)"
                                    gap={4}
                                >
                                    <Box>
                                        <Text
                                            mb={2}
                                            fontWeight="600"
                                        >
                                            Registration Number
                                        </Text>

                                        <Input
                                            placeholder="B 123 ABC"
                                            value={
                                                form.registration_number
                                            }
                                            onChange={(
                                                e
                                            ) =>
                                                setForm(
                                                    (
                                                        prev
                                                    ) => ({
                                                        ...prev,
                                                        registration_number:
                                                            e
                                                                .target
                                                                .value,
                                                    })
                                                )
                                            }
                                        />
                                    </Box>

                                    <Box>
                                        <Text
                                            mb={2}
                                            fontWeight="600"
                                        >
                                            Vehicle Make
                                        </Text>

                                        <Input
                                            placeholder="Toyota"
                                            value={
                                                form.vehicle_make
                                            }
                                            onChange={(
                                                e
                                            ) =>
                                                setForm(
                                                    (
                                                        prev
                                                    ) => ({
                                                        ...prev,
                                                        vehicle_make:
                                                            e
                                                                .target
                                                                .value,
                                                    })
                                                )
                                            }
                                        />
                                    </Box>

                                    <Box>
                                        <Text
                                            mb={2}
                                            fontWeight="600"
                                        >
                                            Vehicle Model
                                        </Text>

                                        <Input
                                            placeholder="Corolla"
                                            value={
                                                form.vehicle_model
                                            }
                                            onChange={(
                                                e
                                            ) =>
                                                setForm(
                                                    (
                                                        prev
                                                    ) => ({
                                                        ...prev,
                                                        vehicle_model:
                                                            e
                                                                .target
                                                                .value,
                                                    })
                                                )
                                            }
                                        />
                                    </Box>

                                   <Box>
                                            <Text
                                                mb={2}
                                                fontWeight="600"
                                            >
                                                Vehicle Body Type
                                            </Text>

                                            <select
                                                value={
                                                    form.vehicle_body_type
                                                }
                                                onChange={(e) =>
                                                    setForm(
                                                        prev => ({
                                                            ...prev,
                                                            vehicle_body_type:
                                                                e.target.value,
                                                        })
                                                    )
                                                }
                                                style={{
                                                    width: "100%",
                                                    padding: "12px",
                                                    borderRadius: "10px",
                                                    border: "1px solid #E2E8F0",
                                                    background: "white",
                                                }}
                                            >
                                                <option value="">
                                                    Select Vehicle Body Type
                                                </option>

                                                <option value="Sedan">
                                                    Sedan
                                                </option>

                                                <option value="Hatchback">
                                                    Hatchback
                                                </option>

                                                <option value="SUV">
                                                    SUV
                                                </option>

                                                <option value="Pickup">
                                                    Pickup
                                                </option>

                                                <option value="Truck">
                                                    Truck
                                                </option>

                                                <option value="Van">
                                                    Van
                                                </option>
                                            </select>
                                        </Box>

                                    <Box>
                                        <Text
                                            mb={2}
                                            fontWeight="600"
                                        >
                                            Vehicle Color
                                        </Text>

                                        <Input
                                            placeholder="White"
                                            value={
                                                form.vehicle_color
                                            }
                                            onChange={(
                                                e
                                            ) =>
                                                setForm(
                                                    (
                                                        prev
                                                    ) => ({
                                                        ...prev,
                                                        vehicle_color:
                                                            e
                                                                .target
                                                                .value,
                                                    })
                                                )
                                            }
                                        />
                                    </Box>

                                    <Box>
                                        <Text
                                            mb={2}
                                            fontWeight="600"
                                        >
                                            Chasis Number
                                        </Text>

                                        <Input
                                            placeholder="Enter chasis number"
                                            value={
                                                form.chasis_number
                                            }
                                            onChange={(
                                                e
                                            ) =>
                                                setForm(
                                                    (
                                                        prev
                                                    ) => ({
                                                        ...prev,
                                                        chasis_number:
                                                            e
                                                                .target
                                                                .value,
                                                    })
                                                )
                                            }
                                        />
                                    </Box>

                                    <Box>
                                        <Text
                                            mb={2}
                                            fontWeight="600"
                                        >
                                            Engine Number
                                        </Text>

                                        <Input
                                            placeholder="Enter engine number"
                                            value={
                                                form.engine_number
                                            }
                                            onChange={(
                                                e
                                            ) =>
                                                setForm(
                                                    (
                                                        prev
                                                    ) => ({
                                                        ...prev,
                                                        engine_number:
                                                            e
                                                                .target
                                                                .value,
                                                    })
                                                )
                                            }
                                        />
                                    </Box>

                                    <Box>
                                        <Text
                                            mb={2}
                                            fontWeight="600"
                                        >
                                            Year Of Manufacturing
                                        </Text>

                                        <Input
                                            type="date"
                                            min="1950"
                                            max={
                                                new Date()
                                                    .getFullYear()
                                            }
                                            placeholder="2020"
                                            value={
                                                form.year_of_manufacturing
                                            }
                                            onChange={(e) =>
                                                setForm(
                                                    prev => ({
                                                        ...prev,
                                                        year_of_manufacturing:
                                                            e.target.value,
                                                    })
                                                )
                                            }
                                        />
                                    </Box>
                                </Grid>

                                <AttachmentUpload
                                    title="Blue Book"
                                    description="Upload Blue Book"
                                    files={
                                        form.blue_book
                                    }
                                    onChange={(
                                        files
                                    ) =>
                                        setForm(
                                            (
                                                prev
                                            ) => ({
                                                ...prev,
                                                blue_book:
                                                    files,
                                            })
                                        )
                                    }
                                    maxFiles={1}
                                />

                                <AttachmentUpload
                                    title="Vehicle Image"
                                    description="Upload Vehicle Image"
                                    files={
                                        form.vehicle_image
                                    }
                                    onChange={(
                                        files
                                    ) =>
                                        setForm(
                                            (
                                                prev
                                            ) => ({
                                                ...prev,
                                                vehicle_image:
                                                    files,
                                            })
                                        )
                                    }
                                    maxFiles={1}
                                    accept="image/*"
                                />
                            </VStack>
                        </Drawer.Body>

                        <Drawer.Footer
                            borderTop="1px solid"
                            borderColor="gray.200"
                        >
                            <HStack
                                w="100%"
                                justify="flex-end"
                            >
                                <Button
                                    variant="outline"
                                    onClick={
                                        onClose
                                    }
                                >
                                    Cancel
                                </Button>

                                <Button
                                    bg="#2453FF"
                                    color="white"
                                    disabled={!isFormComplete}
                                    loading={
                                        loading
                                    }
                                    onClick={
                                        handleSubmit
                                    }
                                >
                                    Register Vehicle
                                </Button>
                            </HStack>
                        </Drawer.Footer>
                    </Drawer.Content>
                </Drawer.Positioner>
            </Portal>
        </Drawer.Root>
    );
};

export default AddDriverVehicleDrawer;